import type { FollowUpTone } from '@tracker/shared';

/** Coloured text only — for bordered dropdowns, where a column of filled pills reads as a column of alarms. */
export const TONE_TEXT: Record<FollowUpTone, string> = {
  ok: 'text-emerald-700 dark:text-emerald-400',
  warn: 'text-amber-700 dark:text-amber-400',
  bad: 'text-rose-700 dark:text-rose-400',
  neutral: 'text-muted-foreground',
};

/** Filled pill — same palette as the Badge variants. */
export const TONE_CLASS: Record<FollowUpTone, string> = {
  ok: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/15 dark:text-emerald-400',
  warn: 'bg-amber-100 text-amber-700 dark:bg-amber-500/15 dark:text-amber-400',
  bad: 'bg-rose-100 text-rose-700 dark:bg-rose-500/15 dark:text-rose-400',
  neutral: 'bg-muted text-muted-foreground',
};

export const TONE_BADGE: Record<FollowUpTone, 'success' | 'warning' | 'destructive' | 'secondary'> = {
  ok: 'success',
  warn: 'warning',
  bad: 'destructive',
  neutral: 'secondary',
};
